// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Terminal płatniczy",
    description: "Pobieraj płatności terminalem w recepcji prosto z rezerwacji",
    count: "{count} terminal | {count} terminale",
  },
  settings: {
    title: "Terminale płatnicze w recepcji",
    lead: "Pobieraj płatności terminalem prosto z rezerwacji: kwota pojawia się na urządzeniu, gość płaci kartą, a rezerwacja sama oznacza się jako opłacona.",
    listTitle: "Twoje terminale",
    add: "Dodaj terminal",
    loading: "Ładowanie…",
    empty: "Nie masz jeszcze podłączonego terminala.",
    simulatorTag: "Symulator",
    online: "Online",
    offlineSince: "Offline · ostatni sygnał {when}",
    neverConnected: "Jeszcze nie podłączony",
    bridgeVersion: "mostek {version}",
    token: "token",
    newToken: "Nowy token",
    remove: "Usuń",
    howTitle: "Jak podłączyć",
    how1: "Dodaj tutaj terminal i skopiuj jego token (pokazuje się tylko raz).",
    how2: "Na komputerze w recepcji, do którego podłączony jest terminal, uruchom mostek WACheckin z tym tokenem.",
    how3: "Gdy tutaj pojawi się „Online”, możesz pobierać płatności z dowolnej rezerwacji: Dodaj płatność → Karta / terminal.",
    bankNote: "W przypadku Redsys trzeba zamówić w banku usługę „TPV-PC” (tryb Implantado) i certyfikowany terminal. Samodzielnego terminala WiFi lub 4G nie da się podłączyć.",
    addTitle: "Dodaj terminal",
    nameLabel: "Nazwa",
    namePlaceholder: "Na przykład: Recepcja",
    typeLabel: "Typ",
    typeReal: "Terminal Redsys (TPV-PC)",
    typeRealHint: "Terminal Twojego banku podłączony do komputera w recepcji.",
    typeSim: "Symulator",
    typeSimHint: "Do testów bez urządzenia. Nie przenosi pieniędzy.",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    create: "Dodaj",
    saveError: "Nie udało się zapisać. Spróbuj ponownie.",
    loadError: "Nie udało się wczytać terminali.",
    tokenTitle: "Token terminala",
    tokenLead: "Wpisz te dwie wartości w mostku na komputerze w recepcji.",
    apiLabel: "Serwer",
    tokenLabel: "Token",
    copy: "Kopiuj",
    copied: "Skopiowano",
    tokenOnce: "Zapisz go teraz: nie zostanie pokazany ponownie. Jeśli zginie, wygeneruj nowy, a stary przestanie działać.",
    done: "Gotowe",
    newTokenConfirm: "Wygenerować nowy token dla „{name}”? Obecny przestanie działać i trzeba będzie wpisać go ponownie w mostku.",
    removeConfirm: "Usunąć terminal „{name}”? Nie będzie można już wysyłać do niego płatności.",
    removed: "Terminal usunięty.",
  },
  add: {
    sendTitle: "Pobierz na terminalu",
    sendHint: "Kwota pojawia się na urządzeniu, a rezerwacja sama oznacza się jako opłacona po użyciu karty.",
    online: "online",
    offline: "offline",
    noneOnline: "Żaden terminal nie jest teraz online. Sprawdź, czy komputer w recepcji jest włączony, a mostek uruchomiony.",
    manualTitle: "Już pobrane, tylko zapisz",
    manualHint: "Zostanie zapisane jako opłacone bez użycia terminala.",
    submit: "Pobierz na terminalu",
  },
  line: {
    pendiente: "Wysyłanie do terminala",
    enviado: "Na terminalu",
    sin_respuesta: "Brak odpowiedzi · sprawdź",
  },
  cobro: {
    terminal: "Terminal",
    cancel: "Anuluj płatność",
    hide: "Kontynuuj w tle",
    notCharged: "Nie pobrano",
    wasCharged: "Tak, pobrano",
    retry: "Spróbuj ponownie",
    close: "Zamknij",
    authCode: "Autoryzacja {code}",
    genericError: "Nie udało się dokończyć. Spróbuj ponownie.",
    title: {
      pendiente: "Wysyłanie do terminala…",
      enviado: "Poproś o kartę",
      cobrado: "Pobrano",
      rechazado: "Karta odrzucona",
      cancelado: "Płatność anulowana",
      error: "Terminal zwrócił błąd",
      caducado: "Terminal nie odpowiedział",
      sin_respuesta: "Czy pobrano?",
    },
    text: {
      pendiente: "Kwota pojawi się na terminalu za kilka sekund.",
      enviado: "Kwota jest już na terminalu. Gdy tylko zostanie opłacona, rezerwacja oznaczy się sama.",
      cobrado: "Ta płatność jest już zapisana w rezerwacji.",
      rechazado: "Nic nie pobrano.",
      cancelado: "Nic nie pobrano.",
      error: "Nic nie pobrano.",
      caducado: "Nic nie pobrano.",
      sin_respuesta: "Terminal nie zwrócił wyniku. Sprawdź urządzenie lub paragon, zanim pobierzesz ponownie.",
    },
  },
  qr: {
    button: "Pokaż QR",
    title: "Zeskanuj, aby zapłacić",
    text: "Gość skanuje go telefonem i płaci na bezpiecznej stronie bramki płatniczej. Rezerwacja sama oznacza się jako opłacona.",
    copy: "Kopiuj link",
    copied: "Link skopiowany",
    close: "Zamknij",
  },
};
